<template>
  <div>
    <div class="top">
      <img src="../../assets/关于我们banner.png" alt="" />
    </div>
    <div class="introduce">
      <div class="introduce-top">
        <div>公司介绍</div>

        <img src="../../assets/图层 31@2x.png" alt="" />
      </div>
      <div class="text">{{ CompanyProfile }}</div>
    </div>
    <img class="img" :src="Picture" alt="" />
    <div class="product">
      <div class="i">产品介绍</div>
      <div class="j">{{ Introduction }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgStyle: {
        height: "17px",
        width: "17px",
        // margin: '5px,2,auto',

        // line-height: '30px'
      },
      imgStyle2: {
        height: "30px",
        width: "30px",
      },
      arrData: [],
      index: 0,
      dataTable: {},
      CompanyProfile: "",
      Introduction: "",
      Picture: "",
    };
  },
  created() {
    this.getdevelopmentHistory();
    this.api.openConfig("website_company").then((res) => {
      this.CompanyProfile = res.data?.data?.remark;
    });
    this.api.openConfig("website_client").then((res) => {
      this.Introduction = res.data?.data?.remark;
    });
    this.api.openConfig("webiste_picture").then((res) => {
      this.Picture = res.data?.data?.remark;
    });
  },
  methods: {
    change(value, item) {
      // console.log(value);
      this.index = value;
      // console.log(item);
      this.dataTable = item;
    },
    getdevelopmentHistory() {
      this.api.developmentHistory().then((res) => {
        let aee = res.data.data;
        for (const [key, value] of Object.entries(aee)) {
          // console.log(`this.arrData.${key} = ${value}`);
          this.arrData.push({
            text: key,
            value: value,
          });
        }
        this.dataTable = this.arrData[0];
        console.log(this.arrData);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 1024px) {
  .top {
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .introduce {
    // display: table;
    // border-collapse: collapse;
    margin: 0 auto;
    margin-top: 35px;
    width: 1200px;
    height: 300px;
    // border: 1px solid red;
    .introduce-top {
      display: flex;
      justify-content: space-between;
      height: 120px;
      width: 100%;
      // border: 1px solid red;
      div {
        margin-top: 60px;
        font-size: 44px;
        font-weight: 600;
        // border: 1px solid red;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      img {
        width: 120px;
        height: 120px;
        margin-right: 25px;
        // border: 1px solid red;
      }
    }
    .text {
      margin-top: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 20px;
      line-height: 160%;
      text-align: left;
      font-weight: 300;
      color: #4a4a4a;
      letter-spacing: 1.5px;
    }
  }
  .img {
    width: 1230px;
    height: 820px;
  }
  .product {
    // border: 1px solid red;
    margin: 0 auto;
    width: 1200px;
    height: 450px;
    .i {
      margin-top: 40px;
      font-size: 44px;
      font-weight: 600;
      text-align: left;
      // border: 1px solid red;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .j {
      margin-top: 40px;
      font-size: 20px;
      text-align: left;
      line-height: 180%;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 300;
      color: #4a4a4a;
    }
  }
  .develop {
    .text {
      display: flex;
      margin: 0 auto;
      width: 1200px;
      padding-top: 50px;
      font-size: 44px;
      font-weight: 600;
      text-align: left;
      // border: 1px solid red;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    width: 100%;
    height: 900px;
    background: url("../../assets/bg3\ 拷贝@2x.png");
    background-size: 100% 100%;
    .box {
      width: 1200px;
      height: 680px;
      margin: 0 auto;
      margin-top: 50px;
      // border: 1px solid;
      display: flex;

      .j {
        // border: 1px solid;
        position: relative;
        .p {
          margin-left: 80px;
          // border: 1px solid;
          width: 20px;
          height: 95%;
          border-right: 1px dashed #000;
        }
        .time-box {
          // border: 1px solid red;
          top: 0;
          width: 116px;
          height: 680px;
          position: absolute;
          .time-box-j {
            margin-top: 100px;
            display: flex;
            justify-content: space-between;

            .image {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;

              // margin: auto;
              // margin-top: 5px;
              // margin-left: 5px;
              // line-height: 30px;
            }
          }
          .time {
            font-size: 24px;
            font-weight: bold;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #4a4a4a;
          }
        }
      }
      .course {
        margin-left: 70px;
        width: 870px;
        height: 100%;

        .time-name {
          height: 60px;
          width: 100%;

          text-align: left;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #364664;
        }
        .content::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .content {
          margin-top: 10px;
          width: 970px;
          height: 526px;
          // border: 1px solid;
          overflow: scroll;
          // overflow-y:hidden
          scrollbar-width: none; /* firefox */

          -ms-overflow-style: none; /* IE 10+ */

          overflow-x: hidden;

          // overflow-y: auto;

          .content-text {
            font-size: 18px;
            margin-top: 30px;
            text-align: left;
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .top {
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .introduce {
    // display: table;
    // border-collapse: collapse;
    margin: 0 auto;
    margin-top: 25px;
    width: 300px;
    height: 300px;
    // border: 1px solid red;
    .introduce-top {
      display: flex;
      justify-content: space-between;
      height: 100px;
      width: 100%;
      // border: 1px solid red;
      div {
        margin-top: 30px;
        font-size: 24px;
        font-weight: 600;
        // border: 1px solid red;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      img {
        width: 60px;
        height: 60px;
        margin-right: 25px;
        // border: 1px solid red;
      }
    }
    .text {
      // margin-top: 0px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 15px;
      line-height: 160%;
      text-align: left;
      font-weight: 400;
      color: #4a4a4a;
      letter-spacing: 1.5px;
    }
  }
  .img {
    width: 300px;
    height: 220px;
  }
  .product {
    // border: 1px solid red;
    margin: 0 auto;
    width: 300px;
    height: 550px;
    .i {
      margin-top: 40px;
      font-size: 24px;
      font-weight: 600;
      text-align: left;
      // border: 1px solid red;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .j {
      margin-top: 40px;
      font-size: 15px;
      text-align: left;
      line-height: 180%;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 400;
      color: #4a4a4a;
    }
  }
  .develop {
    .text {
      display: flex;
      margin: 0 auto;
      width: 300px;
      padding-top: 50px;
      font-size: 24px;
      font-weight: 600;
      text-align: left;
      // border: 1px solid red;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    width: 100%;
    height: 770px;
    // border: 1px solid red;
    background: url("../../assets/bg3\ 拷贝@2x.png");
    background-size: 100% 100%;
    .box {
      width: 280px;
      height: 680px;
      margin: 0 auto;
      margin-top: 20px;
      // border: 1px solid;
      display: flex;
      // border: 1px solid;
      .j {
        // border: 1px solid;
        position: relative;
        .p {
          // margin-left: 0px;
          // border: 1px solid;
          width: 10px;
          height: 80%;
          border-right: 1px dashed #000;
        }
        .time-box {
          // border: 1px solid red;
          top: 0;
          left: -45px;
          width: 70px;
          height: 680px;
          position: absolute;
          .time-box-j {
            margin-top: 80px;
            display: flex;
            justify-content: space-between;

            .image {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;

              // margin: auto;
              // margin-top: 5px;
              // margin-left: 5px;
              // line-height: 30px;
            }
          }
          .time {
            margin-top: 5px;
            font-size: 15px;
            font-weight: bold;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #4a4a4a;
          }
        }
      }
      .course {
        margin-left: 20px;
        width: 290px;
        height: 100%;
        // border: 1px solid;
        .time-name {
          height: 30px;
          width: 100%;

          text-align: left;
          font-size: 17px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #364664;
        }
        .content::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .content {
          margin-top: 10px;
          width: 290px;
          height: 526px;
          // border: 1px solid;
          overflow: scroll;
          // overflow-y:hidden
          scrollbar-width: none; /* firefox */

          -ms-overflow-style: none; /* IE 10+ */

          overflow-x: hidden;

          // overflow-y: auto;

          .content-text {
            font-size: 18px;
            margin-top: 30px;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
